<script lang="ts" setup>
const {
  public: { googlePlayLink },
} = useRuntimeConfig()

const { t } = useI18n()
</script>

<template>
  <NuxtLink
    :to="googlePlayLink"
    target="_blank"
    aria-label="Belong in Google Play"
  >
    <div
      class="p-0.25 rounded-full overflow-hidden common-gradient before:bg-gradient-to-r before:from-[#7540ee] before:via-[#4467ff] before:to-[#ff8fe9] before:rounded-full relative"
    >
      <div
        class="bg-[#00000033] rounded-full flex flex-row items-center gap-2 py-2.5 px-3.5"
      >
        <Icon name="belong:google-play" class="w-5 h-5" />
        <p class="uppercase font-medium text-sm tracking-wide">
          {{ t('google-play-0') }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>
